export class EmployeeReportRequest {
    name: string;
    surname: string;
    departmentId: number;
    titleId: number;
    birthDateMin?: string;
    birthDateMax?: string;
    gender?: string;
}

export class EmployeeReportDto {
    ad: string;
    soyad: string;
    baslama_tarihi: string;
    tck: string;
    tel: string;
    email: string;
    departman: string;
    unvan: string;
    yonetici: string;
    dogum_tarihi: string;
    cinsiyet: string;
}


export class AbsenceDeservedReportDto {
    ad: string;
    soyad: string;
    baslama_tarihi: string;
    email: string;
    izin_turu: string;
    hak_edis_tarihi: string;
    zaman_birimi: string;
    hakedilen: number;
    aktarilan: number;
    kullanilabilir: number;
    kullanilan: number;
    kalan: number;
}

export class EmployeeReportResponse {
    sheet1: EmployeeReportDto[];
    sheet2: AbsenceDeservedReportDto[];
    sheet3: AbsenceDeservedReportDto[];
    sheetNames: string[];
    workBookName: string;
}
